import AOS from 'aos';

AOS.init({
    disable: window.innerWidth < 960,
    offset: 50,
    duration: 1000,
    once: true,
});